import styled from 'styled-components'

export const Container = styled.h1`
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    color: #006600;
    margin: 30px 0;
    font-size: 25px;
`